// Sends the user's identity to analytics (Clarity identify + custom tags and
// GA user_id) on every hard page load for authenticated visitors.
// Without this, identity only fires inside the form/package flows that
// dispatch user/getUser, so sessions that never touch those flows are
// unfilterable by uid/email in Clarity.
//
// Gated on the ln_auth_status cookie so anonymous visitors never trigger a
// /profile request. getUser already handles its own errors.
export default function ({ store }) {
  const cookies = document.cookie ? document.cookie.split(';') : []
  const isAuthenticated = cookies.some(function (cookie) {
    return cookie.trim().indexOf('ln_auth_status=1') === 0
  })
  if (!isAuthenticated) {
    return
  }
  store.dispatch('user/getUser')
}
